<template>
  <div class="cookie-info">
    <div class="cookie-info__text">
      На этом веб-сайте мы и наши партнеры используем cookie – файлы для
      упрощения навигации, персонализации контента, адаптации рекламы в
      соответствии с Вашими интересами и оценки использования сайта. Узнайте
      больше об использовании cookie - файлов.<br />Чтобы согласиться с нашим
      использованием cookie-файлов, нажмите «Принимаю». Чтобы настроить Ваши
      конкретные предпочтения, нажмите «Настройки cookie-файлов».
    </div>
    <div class="cookie-info__actions">
      <div class="_settings">Настройки cookie-файлов</div>
      <div class="_btn" @click="acceptCookie()">
        <svg
          class="_border-l"
          width="11"
          height="43"
          viewBox="0 0 14 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.23022 1.66547C10.3469 0.596611 11.8331 0 13.3789 0H14V56H13.3789C11.8331 56 10.3469 55.4034 9.23022 54.3345L1.85128 47.2719C0.668764 46.1401 0 44.5743 0 42.9374V13.0626C0 11.4257 0.668764 9.8599 1.85128 8.72808L9.23022 1.66547Z"
            fill="#00188A"
          /></svg
        >Принимаю
        <svg
          class="_border-r"
          width="11"
          height="43"
          viewBox="0 0 14 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.76978 54.3345C3.65305 55.4034 2.16688 56 0.621068 56H0L0 0H0.621069C2.16688 0 3.65305 0.596611 4.76978 1.66547L12.1487 8.72808C13.3312 9.85991 14 11.4257 14 13.0626L14 42.9374C14 44.5743 13.3312 46.1401 12.1487 47.2719L4.76978 54.3345Z"
            fill="#00188A"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieInfo",
  methods: {
    acceptCookie() {
      this.$emit("accept")
      localStorage.setItem("tuc-cookie", 1)
    },
  },
}
</script>

<style lang="scss">
.cookie-info {
  position: fixed;
  right: 40px;
  bottom: 40px;
  background-color: white;
  border-radius: 32px;
  padding: 32px 40px;
  max-width: 506px;
  z-index: 1000;
  &__text {
    font-family: $font-text;
    font-size: 1.2rem;
    line-height: 140%;
    color: $color-blue;
  }
  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ._settings {
      font-family: $font-text;
      font-size: 1.2rem;
      font-weight: 700;
      text-decoration: underline;
      color: $color-blue;
    }
    ._btn {
      font-family: $font-peach;
      font-size: 2.1rem;
      color: white;
      background-color: $color-blue;
      position: relative;
      height: 43px;
      padding: 0 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      svg {
        position: absolute;
        top: 0;
      }
      ._border-l {
        left: -10px;
      }
      ._border-r {
        right: -10px;
      }
    }
  }
}

@include respond-to("smartphone-plus") {
  .cookie-info {
    padding: 30px;
    width: calc(100% - 40px);
    right: 20px;
    bottom: 60px;
  }
}
</style>
